import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <CollisionShape3D>: a transform-only node whose collision-shape resource draws as a wireframe
 * gizmo (ADR-0005 / ADR-0006). The gizmo shows only while `ViewportModeContext.showCollisions`
 * is on (off by default), like Godot's "Visible Collision Shapes".
 */
import { useMemo } from 'react';
import { node3dGroupSpread, transformFromNode3DProperties } from '../../../../r3f/nodeTransform';
import { useSceneResources } from '../../../../r3f/SceneResourcesContext';
import { useSubOrExtResource } from '../../../../resources/useSubOrExtResource';
import { useViewportMode } from '../../../../r3f/contexts/ViewportModeContext';
import { CollisionGizmo } from './CollisionGizmo';
import { useGodotLinearColor } from '../../../../r3f/godotColor';
import { DEFAULT_COLLISION_DEBUG_COLOR } from '../../shared/debugColor';
export function CollisionShape3D({ node, children }) {
    const properties = node.properties;
    const sceneResources = useSceneResources();
    const { showCollisions } = useViewportMode();
    const transform = useMemo(() => transformFromNode3DProperties(properties), [properties]);
    const shapeResource = useSubOrExtResource(properties.shape, sceneResources)?.resource;
    // Godot draws the shape in the node's own `debug_color`. The literal is sRGB.
    const debugColor = useGodotLinearColor(properties.debugColor ?? DEFAULT_COLLISION_DEBUG_COLOR);
    return (_jsxs("group", { name: node.name, ...node3dGroupSpread(transform), children: [showCollisions && shapeResource ? _jsx(CollisionGizmo, { shape: shapeResource, color: debugColor }) : null, children] }));
}
//# sourceMappingURL=Component.js.map